<template>
    <div class="relative" dusk="ColorButton">
        <BaseButton
            class="text-theme-toolbar-icon"
            :tooltip="localizations[lang].tooltips.createHighlight"
            :icon-custom-style="iconColorStyle"
            icon="highlighter-24px"
            type="button"
            @click="toggleColorsMenu"
        />
        <transition name="slide-fade">
            <ListDropdown
                v-show="showColorsItems"
                class="left-[-9px] text-theme-toolbar-icon"
                :submenu-display-in-down="submenuDisplayInDown"
            >
                <!-- The panel widens while the highlighter form holds the row -->
                <div class="p-1" :class="panelWidthClass">
                    <HighlighterColorPicker
                        variant="compact"
                        :selected-slug="currentHighlight.colorSlug"
                        :show-delete-highlight="currentHighlight.canBeDeleted()"
                        @select="handleColorSelect"
                        @delete-highlight="deleteSelection"
                        @form-toggle="isHighlighterFormOpen = $event"
                    />
                </div>
            </ListDropdown>
        </transition>
    </div>
</template>

<script>
import BaseButton from '../../Components/buttons/BaseButton.vue';
import ListDropdown from '../../Components/list/ListDropdown.vue';
import HighlighterColorPicker from '../../HighlighterColorPicker/HighlighterColorPicker.vue';
import { mapState } from 'vuex';

export default {
    components: {
        BaseButton,
        ListDropdown,
        HighlighterColorPicker,
    },

    props: {
        applyColorAndConfirmSelection: {
            type: Function,
            required: true,
        },
        toggleColorsMenu: {
            type: Function,
            required: true,
        },
        showColorsItems: {
            type: Boolean,
            required: true,
        },
        submenuDisplayInDown: {
            type: Boolean,
            required: true,
        },
    },

    emits: ['delete-selection'],

    data() {
        return {
            /** Whether the highlighter form, rather than the palette, holds the row. */
            isHighlighterFormOpen: false,
        };
    },

    computed: {
        ...mapState(['localizations', 'currentHighlight', 'lang']),

        panelWidthClass() {
            return this.isHighlighterFormOpen
                ? 'w-[min(420px,calc(100vw_-_1rem))]'
                : 'w-[min(280px,calc(100vw_-_1rem))]';
        },

        iconColorStyle() {
            const color = this.currentHighlight.color || 'transparent';
            return { color };
        },
    },

    methods: {
        /**
         * Handles color selection from the picker and applies it.
         * @param {{ color: string, slug: string }} payload - Selected color data
         */
        handleColorSelect(payload) {
            this.applyColorAndConfirmSelection(payload.color, payload.slug);
        },

        deleteSelection() {
            this.$emit('delete-selection');
        },
    },
};
</script>
